// @flow
import React, { Component } from 'react';
import {
  ConfirmationModalButtons,
  ConfirmationModalDiv,
  SuccessModalA,
  ConfirmationModalContentDiv
} from './ModalConductorStyles';
export type SuccessModalPayload = {
  title: string,
  message: string,
  onConfirm?: () => void,
  confirmText?: string
};
type Props = {
  closeModal: () => void,
  ...$Exact<SuccessModalPayload>
};

export default class SuccessModal extends Component<Props> {
  static defaultProps = {
    confirmText: 'OK'
  };
  confirm = () => {
    this.props.closeModal();
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  };
  render() {
    return (
      <ConfirmationModalDiv>
        <ConfirmationModalContentDiv>
          <h4>{this.props.title}</h4>
          <p>{this.props.message}</p>
        </ConfirmationModalContentDiv>
        <ConfirmationModalButtons>
          <SuccessModalA onClick={this.confirm}>
            {this.props.confirmText}
          </SuccessModalA>
        </ConfirmationModalButtons>
      </ConfirmationModalDiv>
    );
  }
}
